import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import { arrayToObject } from 'lib/array/arrayUtils'
import { convertPointsToPrice } from 'constants/merchandise'
import qs from 'qs'

type Response = paths['/api/merchandise/search/adverts']['get']['responses']['200']['content']['application/json']

async function getMerchandiseList(filters: App.MerchandiseFilters): Promise<Array<Response['result']['adverts'][number]>> {
  // Map legacy points filters to price filters using burn rate
  const mappedPriceMin = filters.price?.min ?? (filters.points?.min !== undefined ? convertPointsToPrice(filters.points.min) : undefined)
  const mappedPriceMax = filters.price?.max ?? (filters.points?.max !== undefined ? convertPointsToPrice(filters.points.max) : undefined)

  const query = qs.stringify({
    name: filters.name || undefined,
    categoryIds: filters.categories?.length ? filters.categories : undefined,
    brandIds: filters.brands?.length ? filters.brands : undefined,
    priceMin: mappedPriceMin ?? undefined,
    priceMax: mappedPriceMax ?? undefined,
    sortBy: filters.sortBy || undefined,
    excludedAdvertIds: filters.excludedAdvertIds?.length ? filters.excludedAdvertIds : undefined,
    tags: filters.tags?.length ? filters.tags : undefined,
    freeShipping: filters.freeShipping?.length ? true : undefined,
    // search facets endpoint assumes any other field is an option filter
    ...arrayToObject(filters.options ?? [], option => option.type, option => option.value),
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/search/adverts?${query}`, { excludeBrand: true }).then((response) => {
    return response.result.adverts
  })
}

export default getMerchandiseList
